import React, { useState } from "react";
import Sidebar from "../components/Sidebar";

interface Campaign {
  id: string;
  name: string;
  type: string;
  status: string;
  budget: number;
  spent: number;
  startDate: string;
  endDate: string;
}

const Campaigns: React.FC = () => {
  const [campaigns, setCampaigns] = useState<Campaign[]>([
    { id: "CMP-001", name: "แคมเปญ Summer Sale", type: "discount", status: "active", budget: 50000, spent: 25000, startDate: "2026-04-01", endDate: "2026-04-30" },
    { id: "CMP-002", name: "โปรโมชั่น PromptPay", type: "payment", status: "active", budget: 30000, spent: 15000, startDate: "2026-04-15", endDate: "2026-05-15" },
    { id: "CMP-003", name: "แคมเปญ วันแม่", type: "seasonal", status: "scheduled", budget: 80000, spent: 0, startDate: "2026-08-01", endDate: "2026-08-31" },
  ]);

  const getStatusColor = (status: string) => {
    const colors: Record<string, string> = { active: "bg-green-100 text-green-800", scheduled: "bg-blue-100 text-blue-800", completed: "bg-gray-100 text-gray-800", paused: "bg-yellow-100 text-yellow-800" };
    return colors[status] || "bg-gray-100 text-gray-800";
  };

  const getStatusLabel = (status: string) => {
    const labels: Record<string, string> = { active: "กำลังดำเนินการ", scheduled: "ตารางงาน", completed: "เสร็จสิ้น", paused: "หยุดชั่วคราว" };
    return labels[status] || status;
  };

  return (
    <div className="flex min-h-screen bg-gray-100">
      <Sidebar />
      <div className="flex-1 p-8">
        <div className="max-w-7xl mx-auto">
          <h1 className="text-3xl font-bold text-gray-900 mb-2">แคมเปญ</h1>
          <p className="text-gray-600 mb-6">จัดการแคมเปญการตลาดและโปรโมชั่น</p>

          <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mb-6">
            <div className="bg-white rounded-lg shadow p-4 border border-gray-200">
              <p className="text-sm text-gray-600">แคมเปญทั้งหมด</p>
              <p className="text-2xl font-bold text-gray-900">{campaigns.length}</p>
            </div>
            <div className="bg-white rounded-lg shadow p-4 border border-gray-200">
              <p className="text-sm text-gray-600">กำลังดำเนินการ</p>
              <p className="text-2xl font-bold text-green-600">{campaigns.filter((c) => c.status === "active").length}</p>
            </div>
            <div className="bg-white rounded-lg shadow p-4 border border-gray-200">
              <p className="text-sm text-gray-600">งบประมาณรวม</p>
              <p className="text-2xl font-bold text-blue-600">฿{campaigns.reduce((sum, c) => sum + c.budget, 0).toLocaleString()}</p>
            </div>
            <div className="bg-white rounded-lg shadow p-4 border border-gray-200">
              <p className="text-sm text-gray-600">ใช้ไปแล้ว</p>
              <p className="text-2xl font-bold text-purple-600">฿{campaigns.reduce((sum, c) => sum + c.spent, 0).toLocaleString()}</p>
            </div>
          </div>

          <div className="bg-white rounded-lg shadow overflow-hidden border border-gray-200">
            <table className="w-full">
              <thead className="bg-gray-50 border-b border-gray-200">
                <tr>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">ชื่อแคมเปญ</th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">ประเภท</th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">สถานะ</th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">งบประมาณ</th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">ใช้ไป</th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">วันที่เริ่ม</th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">วันที่สิ้นสุด</th>
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-200">
                {campaigns.map((campaign) => (
                  <tr key={campaign.id} className="hover:bg-gray-50">
                    <td className="px-6 py-4 text-sm text-gray-900">{campaign.name}</td>
                    <td className="px-6 py-4 text-sm text-gray-900">{campaign.type}</td>
                    <td className="px-6 py-4">
                      <span className={`px-2 py-1 text-xs rounded-full ${getStatusColor(campaign.status)}`}>
                        {getStatusLabel(campaign.status)}
                      </span>
                    </td>
                    <td className="px-6 py-4 text-sm text-gray-900">฿{campaign.budget.toLocaleString()}</td>
                    <td className="px-6 py-4 text-sm text-gray-900">฿{campaign.spent.toLocaleString()}</td>
                    <td className="px-6 py-4 text-sm text-gray-900">{campaign.startDate}</td>
                    <td className="px-6 py-4 text-sm text-gray-900">{campaign.endDate}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Campaigns;
